import { render } from "./PagePublicidade.vue?vue&type=template&id=237ec0a3&scoped=true"
import script from "./PagePublicidade.vue?vue&type=script&lang=js"
export * from "./PagePublicidade.vue?vue&type=script&lang=js"

import "./PagePublicidade.vue?vue&type=style&index=0&id=237ec0a3&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237ec0a3"]])

export default __exports__